@if (showStripeMessage) {
    <div class="mt-10 flex flex-col items-center gap-2 text-center">
        <h5 class="text-base font-semibold text-slate-200">{{'core.instructions1' | translate}}</h5>
        <h6 class="text-sm text-slate-400">{{'core.instructions2' | translate}}</h6>
        <a [routerLink]="['/stripeAccount']" routerLinkActive="router-link-active"  class="clp-btn clp-btn-warning clp-btn-sm mt-4">{{'core.cta' | translate}}</a>
    </div>
}
